const NightStatusEnum = {
  CLOSED: 'closed',
  NOT_OFFERED: 'notOffered',
};

export default NightStatusEnum;
